import debounce from 'lodash/debounce'
import $ from 'jquery'
import mediaLoaded from '@maeertin/medialoaded'

const $window = $(window)

/**
 * Set video's src attribute.
 * 
 * @param {jQuery} $video 
 * @param {string} src 
 */
function setSrc($video, src) {
    const paused = $video.get(0).paused

    if ($video.attr('src') !== src) {
        $video.attr('src', src)
        paused || $video.get(0).play()
    }
}

/**
 * Update video file based on the screen size.
 * 
 * @param {jQuery} $video 
 */
function updateSrc($video) {
    const vw        = $window.width()
    const vh        = $window.height()
    const portrait  = $video.data('portrait-src')

    // If mobile and portrait
    if (portrait && vw < 576 && vw < vh) {
        setSrc($video, portrait)
    } 
    // Otherwise treat as landscape
    else {
        const videos = $video.data('srcs')
        // Video widths sorted in ascending order
        const widths = Object.keys(videos).sort((a, b) => a - b)
        // Video width for the current viewport
        const width = widths.find(width => vw <= width) || widths[widths.length - 1]

        setSrc($video, videos[width])
    }
}

let $body   = $(document.body)
let $hero   = $body.find('.hero-section')
let $video  = $hero.find('video')

if ($video.length) {
    updateSrc($video)
    $window.on('resize', debounce(updateSrc.bind(undefined, $video), 100))
}

$hero.on('st-in', () => {    
    // Wait for header transition, then play the video.
    setTimeout(() => {
        if ($video.length) {
            let video = $video.get(0)   

            mediaLoaded(video, instance => {
                $hero.addClass('media-ready')
                $body.addClass('light-nav')      
                video.play()
            })
        } else {
            let $bg = $hero.children('.bg')
            
            $bg.imagesLoaded({ background: true }, () => {
                $hero.addClass('media-ready')
                $body.addClass('light-nav')
            })
        }
    }, $window.width() > 1200 ? 1500 : 0)    
})